/**
 * Что спрятано с экрана и из крона, пока врёт или пусто.
 *
 * Код не удаляли. API не ломали. Чтобы вернуть пачку — снять флаг и
 * выкатить web (адрес — ещё caddy). Карта: docs/parked/.
 *
 * true = спрятано.
 */
export const parked = {
  /** Карта смены и /v1/hours. */
  hours: true,
  /** Вкладка и режим коридоров. */
  middles: true,
  /** Касса: страница, шапка, полоса. Журнал — «моя статистика». */
  book: true,
  /** «Слать это сито» в Telegram. Бот по ленте жив — это не он. */
  watchTg: true,
  /** Колокольчик браузера. Динамик не отсюда. */
  browserPush: true,
  /** Шаг студии «антидект» / AdsPower. false = стол Local API снова на экране. */
  adsPower: false,
  /** Мёртвые ручки студии: сигнал, зеркало, потолок, судьбы, музей. */
  studioDeadKnobs: true,
  /** Кнопки контор только из meta.sources, не справочник на 43 имени. */
  ghostVenues: true,
  /** Две страницы лайв/прематч. false = /app и /app/live — лайв, /app/prematch — прематч. */
  linePages: false,
  /** Вкладка «тест», адрес /app/test и контур /tests. Код страницы не удаляли. */
  tests: true,
  /** «Русские»: отдельное зеркало forq-cha-ru → forq-russkie-v2. false = показать. */
  russkie: false,
  /** Вкладка «переливы»: forq-cha-ru → forq-transfers-v2. false = показать. */
  transfers: false,
  /** Вкладка «предикт»: Polymarket × Predict.fun, контейнер forq-predict. true = спрятано, воркер остановлен. */
  predict: true,
  /** Вкладка «лента 2.0»: зеркало BetBurger на /tests, отдельный контейнер forq-feed2. */
  lenta2: false,
  /** Вкладка «лента 3.0»: свой кабинет и контейнер forq-feed3, не 2.0. */
  lenta3: true,
  /** Вкладка «лента 5.0»: теперь фишка сита и кнопка в шапке, не /v5/app. */
  lenta5: false,
  /**
   * Страница /forecast. false = открыта для пробы.
   * Сервер FORECAST_* на живом v2 ещё выключен: страница рисует последний прогон.
   */
  forecast: false,
} as const;

export type ParkedFlag = keyof typeof parked;
